import { render, staticRenderFns } from "./ScottNotes.vue?vue&type=template&id=5a6a4754"
import script from "./ScottNotes.vue?vue&type=script&lang=js"
export * from "./ScottNotes.vue?vue&type=script&lang=js"
import style0 from "./ScottNotes.vue?vue&type=style&index=0&id=5a6a4754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports